(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Quick add (delegación para que funcione también con infinite scroll)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.quick-add-btn');
    if (!btn) return;

    e.preventDefault();
    if (btn.disabled) return;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.innerHTML = 'Añadiendo…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });

      if (!res.ok) throw new Error('Add to cart failed');

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.innerHTML = '✓ Añadido';

      // Opcional: lanzar evento para que el tema actualice contador/drawer si lo usa
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(() => {
        btn.classList.remove('is-added');
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }, 1400);
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      btn.innerHTML = 'Error';
      setTimeout(() => {
        btn.classList.remove('is-error');
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }, 1400);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
